// extracted by mini-css-extract-plugin
export default {"instruction_paragraph_container":"footer_instruction_paragraph_container__r++VZ","lioncontainer":"footer_lioncontainer__aOfW2","lion":"footer_lion__Wfn6L"};